import useSWR from 'swr';
import getFilterViews from 'modules/emergencies/api/getFilterViews';

// returns tickets with loading/reloading state
const useFilterViewsList = (props) => {
  const { data: filterViewsData, error: filterViewsError } = useSWR(
    `filter-views`,
    getFilterViews,
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
  const isLoadingFilterViews = typeof filterViewsData === 'undefined' && !filterViewsError;

  return {
    filterViewsData,
    filterViewsError,
    isLoadingFilterViews,
  };
};

export default useFilterViewsList;
